import { cn } from "@/lib/utils";

/**
 * Inline SVG fractalNoise tile used to add the "Grainy Gradient" texture
 * over a coloured surface. The first feColorMatrix desaturates the noise
 * to grayscale; the second stretches contrast so the values straddle 128
 * (mix-blend-overlay needs both above- and below-128 samples to lighten
 * *and* darken the underlying gradient).
 */
const GRAIN_BG =
  "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='240' height='240'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='2' stitchTiles='stitch'/><feColorMatrix type='saturate' values='0'/><feColorMatrix values='1.6 0 0 0 -0.8  0 1.6 0 0 -0.8  0 0 1.6 0 -0.8  0 0 0 1 0'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")";

interface VsGrainOverlayProps {
  className?: string;
}

/**
 * Absolute-positioned grain texture for any gradient surface on the
 * Visionaries Summit page. Drop it as the first child of a positioning
 * context; the parent should `overflow-hidden` if the surface has rounded
 * or non-rectangular bounds.
 */
export function VsGrainOverlay({ className }: VsGrainOverlayProps) {
  return (
    <div
      aria-hidden
      style={{ backgroundImage: GRAIN_BG }}
      className={cn(
        "pointer-events-none absolute inset-0 opacity-60 mix-blend-soft-light",
        className
      )}
    />
  );
}
